import React, { useState, useMemo } from 'react';
import { Row, Col } from 'reactstrap';

import VersionerDocumentItemSelect from '../item/select';
import VersionerDocumentComparisonContainer from '../comparison/container';

const VersionerDocumentThreadContainer = (props) => {
  const { configuration } = props;

  const [selectedItemId, setSelectedItemId] = useState(props?.thread?.items[0]?.id || null)

  const [thread, setThread] = useState(props?.thread)

  const currentItem = useMemo(() => {
    return _.find(thread?.items, { id: selectedItemId }) || null
  }, [selectedItemId, thread])

  const previousItem = useMemo(() => {
    return _.find(thread.items, item => item?.id < currentItem?.id);
  }, [currentItem?.id, thread]);

  const isPortalContext = useMemo(() => {
    return configuration?.context === 'portal'
  }, [configuration?.context])

  const itemName = (item) => {
    return `${I18n.t('activerecord.models.versioner/document/item.one')} ${moment(item?.created_at).format('DD/MM/YYYY HH:mm')}`;
  }

  return (
    <Row>
      <Col md={12} className="mb-3">
        <VersionerDocumentItemSelect
          thread={thread}
          selectedItemId={ selectedItemId }
          callbacks={{
            setSelectedItemId
          }}
          helpers={{
            itemName: itemName
          }}
        />
      </Col>

      <Col md={12}>
        <VersionerDocumentComparisonContainer
          key={`VersionerDocumentComparisonContainer-${currentItem?.id}-${previousItem?.id}`}
          thread={thread}
          currentItem={currentItem}
          previousItem={previousItem}
          helpers={{
            itemName: itemName,
            isPortalContext: isPortalContext
          }}
          configuration={configuration}
          data={ props?.data }
          callbacks={{
            setThread
          }}
        />
      </Col>
    </Row>
  );
};

export default VersionerDocumentThreadContainer;
